import Image from 'components/Image';
import withSettings from 'hocs/withSettings';
import * as ComponentUtils from 'utils/component';
import { createImagePlaceholder } from 'utils/imageUtils';

const MenuItemImage = ({ className, style, imageSrc, name, width, height, isLazyLoading = false, settings }) => {
    // Get image src
    let src = imageSrc;
    if (!src) src = settings.viewDefaultMenuItemImage ?? createImagePlaceholder(name);

    return (
        <Image
            className={className}
            style={style}
            imageSrc={src}
            width={width}
            height={height}
            isLazyLoading={isLazyLoading}
        />
    );
};

const hocs = [withSettings];

export default ComponentUtils.compose(hocs)(MenuItemImage);
